<div class="content-container">

  <div class="section full-bleed section-image">
    <img src="/assets/images/payment-request.jpg" alt="" />
  </div>

    <div class="section text-block section-heading">
      <div class="banner-heading" [style.backgroundImage]="'url(/assets/images/payment-request.jpg)'"></div>
  </div>

  <div class="text-block">
    <h1 class="heading">{{ locale.imageText }}</h1>
    <p>{{ locale.paragraphOne }}</p>

    <ul>
      <li>{{ locale.bulletOne }}</li>
      <li>{{ locale.bulletTwo }}</li>
      <li>{{ locale.bulletThree }}</li>
    </ul>

    <p>{{ locale.paragraphTwo }}</p>
    <p>{{ locale.paragraphthree }}</p>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/account/request-payment/request-payment.component.html